import snakecaseKeys from 'snakecase-keys';
import { InjectiveExchangeV2Tx } from '@injectivelabs/core-proto-ts';
import { MsgBase } from '../../MsgBase.js';
const createMessage = (params) => {
    const message = InjectiveExchangeV2Tx.MsgCancelPostOnlyMode.create();
    message.sender = params.sender;
    return InjectiveExchangeV2Tx.MsgCancelPostOnlyMode.fromPartial(message);
};
/**
 * @category Messages
 */
export default class MsgCancelPostOnlyModeV2 extends MsgBase {
    static fromJSON(params) {
        return new MsgCancelPostOnlyModeV2(params);
    }
    toProto() {
        const { params: initialParams } = this;
        const params = {
            ...initialParams,
        };
        return createMessage(params);
    }
    toData() {
        const proto = this.toProto();
        return {
            '@type': '/injective.exchange.v2.MsgCancelPostOnlyMode',
            ...proto,
        };
    }
    toAmino() {
        const { params } = this;
        const msg = createMessage(params);
        const message = {
            ...snakecaseKeys(msg),
        };
        return {
            type: 'exchange/MsgCancelPostOnlyMode',
            value: message,
        };
    }
    toWeb3Gw() {
        const amino = this.toAmino();
        const { value } = amino;
        return {
            '@type': '/injective.exchange.v2.MsgCancelPostOnlyMode',
            ...value,
        };
    }
    toEip712() {
        const amino = this.toAmino();
        const { type, value } = amino;
        const messageAdjusted = {
            ...value,
        };
        return {
            type,
            value: messageAdjusted,
        };
    }
    toEip712V2() {
        const web3gw = this.toWeb3Gw();
        const messageAdjusted = {
            ...web3gw,
        };
        return messageAdjusted;
    }
    toDirectSign() {
        const proto = this.toProto();
        return {
            type: '/injective.exchange.v2.MsgCancelPostOnlyMode',
            message: proto,
        };
    }
    toBinary() {
        return InjectiveExchangeV2Tx.MsgCancelPostOnlyMode.encode(this.toProto()).finish();
    }
}
